import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m7.5 11.52-5-4.8 5-4.8c.474-.469.618-1.1.144-1.568a1.22 1.22 0 0 0-1.713 0L.355 5.872a1.19 1.19 0 0 0 0 1.696l5.576 5.52c.474.47 1.24.47 1.713 0 .462-.469.33-1.099-.144-1.568"
    }, null, -1)
  ])))
}
export default { render: render }